import { render, staticRenderFns } from "./invitacion.view.vue?vue&type=template&id=13829c35&"
import script from "./invitacion.view.vue?vue&type=script&lang=js&"
export * from "./invitacion.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports